import { grey } from "@mui/material/colors";

const styles = {
  header: {
    py: 1.5,
    px: 2,
    borderBottom: `1px solid ${grey[300]}`,
  },
  headerIcon: {
    color: "#8084FF",
    fontSize: 18,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: "#101828",
  },
  close: {
    fontSize: 14,
    width: 30,
    height: 30,
  },
  creditsBanner: {
    mt: 1.5,
    backgroundColor: "#f9fafb",
    borderRadius: 1,
    px: 1,
    py: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
  },
  creditsText: {
    fontSize: 14,
    color: "#364153",
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  creditsIcon: {
    color: "#8084FF",
    fontSize: 14,
  },
  creditsInfoIcon: {
    color: "info.main",
    cursor: "help",
    fontSize: 13,
    ml: 0.25,
  },
  buyMoreButton: {
    textTransform: "none",
    backgroundColor: "white",
    border: "1px solid rgba(0,0,0,0.1)",
    color: "#0a0a0a",
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 1,
    px: 1.5,
    py: 0.25,
    minHeight: 28,
    "&:hover": { backgroundColor: "white" },
  },
  body: {
    overflowY: "auto",
    px: 2,
    pb: 2,
    width: "100%",
    flex: 1,
    minHeight: 200,
  },
  typing: {
    p: 2,
  },
  draft: {
    px: 2,
    py: 1,
  },
  emptyText: {
    mt: 3,
    px: 1,
    textAlign: "center",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    px: 3,
    py: 5,
    gap: 0.75,
  },
  emptyStateIcon: {
    fontSize: 24,
    color: "#8084FF",
    mb: 0.5,
  },
  emptyStateTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#101828",
  },
  emptyStateBody: {
    fontSize: 12,
    color: "#6a7282",
    maxWidth: 240,
    lineHeight: 1.5,
  },
  quickActions: {
    position: "relative",
    px: 2,
    pt: 0.75,
    pb: 0,
    borderTop: `1px solid ${grey[300]}`,
    display: "flex",
    flexDirection: "column",
    gap: 0.25,
  },
  collapseToggle: {
    position: "absolute",
    top: -10,
    right: 8,
    width: 20,
    height: 20,
    backgroundColor: "white",
    border: `1px solid ${grey[300]}`,
    "&:hover": { backgroundColor: "#fafafa" },
  },
  collapseToggleIcon: {
    fontSize: 9,
    color: "rgba(0, 0, 0, 0.45)",
  },
  quickActionsLabel: {
    color: "#6a7282",
    fontSize: 11,
    fontWeight: 500,
    mt: 0.5,
  },
  chipRow: {
    display: "flex",
    flexWrap: "nowrap",
    gap: 0.5,
    overflowX: "auto",
    overflowY: "hidden",
    pb: 0.25,
    cursor: "grab",
    "&:active": { cursor: "grabbing" },
    // Hide horizontal scrollbar (still scrollable via drag / swipe / shift-wheel).
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },
  chip: {
    flex: "0 0 auto",
    whiteSpace: "nowrap",
    textTransform: "none",
    backgroundColor: "white",
    border: "1px solid rgba(0,0,0,0.1)",
    color: "#0a0a0a",
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 1,
    px: 1.25,
    py: 0,
    minHeight: 24,
    lineHeight: "16px",
    "&:hover": {
      backgroundColor: "#f2f3fe",
      borderColor: "#8084FF",
    },
    "&.Mui-disabled": {
      backgroundColor: "white",
      color: "rgba(0,0,0,0.4)",
    },
  },
  composer: {
    px: 2,
    pt: 1.25,
    pb: 1.5,
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  composerRow: {
    display: "flex",
    gap: 1,
    alignItems: "stretch",
  },
  composerInput: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f3f3f5",
      borderRadius: 1,
      padding: "8px 12px",
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "rgba(0,0,0,0.1)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(0,0,0,0.2)",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      lineHeight: "20px",
    },
  },
  sendButton: {
    backgroundColor: "#8084FF",
    color: "white",
    borderRadius: 1,
    minWidth: 36,
    width: 36,
    alignSelf: "stretch",
    "&:hover": { backgroundColor: "#6970E8" },
    "&.Mui-disabled": {
      backgroundColor: "#8084FF",
      opacity: 0.5,
      color: "white",
    },
  },
  sendIcon: {
    fontSize: 14,
  },
  editingSourceRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    pb: 0.5,
    fontSize: 12,
    color: "#6a7282",
  },
  editingSourceLabel: {
    fontSize: 12,
    color: "#6a7282",
  },
  editingSourceChip: {
    height: 26,
    backgroundColor: "white",
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: 1,
    fontSize: 12,
    fontWeight: 500,
    color: "#101828",
    "&:hover": {
      backgroundColor: "#fafafa",
      borderColor: "rgba(0,0,0,0.2)",
    },
    "& .MuiChip-label": {
      pl: 1,
      pr: 0.5,
    },
    "& .MuiChip-deleteIcon": {
      color: "rgba(0, 0, 0, 0.54)",
      fontSize: 14,
      mr: 0.75,
      ml: 0.5,
      transition: "transform 180ms ease",
      "&:hover": { color: "rgba(0, 0, 0, 0.7)" },
    },
  },
  editingSourceChipOpen: {
    "& .MuiChip-deleteIcon": {
      transform: "rotate(180deg)",
    },
  },
  loadingStack: {
    display: "flex",
    flexDirection: "column",
    gap: 1.25,
    px: 1,
    py: 2,
  },
  loadingBubbleAssistant: {
    backgroundColor: "rgba(0,0,0,0.04)",
    borderRadius: 2,
    width: "78%",
  },
  loadingBubbleUser: {
    backgroundColor: "rgba(128,132,255,0.18)",
    borderRadius: 2,
    width: "55%",
    alignSelf: "flex-end",
  },
};

export default styles;
